'use client';

import { Sizes } from '@actr/style/src/specs';
import {
  Button,
  ButtonSizes,
  ButtonTypes
} from '@actr/ui/src/components/_atoms/button';
import { Space } from '@actr/ui/src/components/_atoms/space';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { Price } from '@actr/ui/src/components/price';
import React, { memo } from 'react';

import { Flight } from '@/services/models/avia/airline';

import * as Styled from './style.css';

export type AirlineFlightsProps = {
  title: string;
  flights: Flight[];
  navigationId: string;
};

const PopularFlights: React.FC<AirlineFlightsProps> = ({ title, flights, navigationId }) => {
  if (!flights) {
    return null;
  }

  return (
    <ContentBlock id={navigationId}>
      <Text tagName="h3" font="title.x2l">
        {title}
      </Text>
      <Space size={Sizes.M} />
      <div className={Styled.FlightsList}>
        {flights.map((flight, index) => (
          <div className={Styled.FlightItem} key={index}>
            <div className={Styled.RouteAndPrice} key={index}>
              <a
                key={index}
                className={Styled.Route}
                href={flight.route.path ? `/${flight.route.path}` : undefined}>
                {flight.route.name}
              </a>
              <Text font="paragraph.m" className={Styled.PriceText}>
                от
                {' '}
                <Price amount={flight.min_price} font="paragraph.m" />
              </Text>
            </div>
            <Button
              className={Styled.Button}
              onClick={() => {
                window.location.href = flight.url;
              }}
              buttonType={ButtonTypes.TERTIARY}
              size={ButtonSizes.XS}>
              Найти
            </Button>
          </div>
        ))}
      </div>
    </ContentBlock>
  );
};

export default memo(PopularFlights);
